import { Search } from '@mui/icons-material';
import {
    Box,
    createFilterOptions,
    FormControl
} from '@mui/material';
import React from 'react';
import {
    NoOptionsTypography,
    OptionCountTypography,
    OptionDescriptionTypography,
    OptionLabelTypography,
    StyledAutocomplete,
    StyledPaper,
    StyledPopper,
    StyledTextField
} from './AutocompleteFieldStyles';
import HillSvg from '../../../assets/icons/hills.svg'
import { ImgContainers, NoOption } from '../../Orders/OrdersStyles';

const AutocompleteField = ({
    label,
    value,
    text,
    onProductChange,
    onSearchTextChange,
    options = [],
    placeholder = 'Search and select',
    showCount = true,
    loading = false,
    disabled = false,
    autoComplete = false,
    multiple = false,
    freeSolo = true,
    noOptionsText = 'No results found',
    ...props
}) => {
    // Ensure options is always an array
    const safeOptions = Array.isArray(options) ? options : [];
    
    // Create filter function that matches label and description
    const filterOptions = createFilterOptions({
        matchFrom: 'any',
        stringify: (option) => `${option.label} ${option.description || ''}`,
    });

    // Show no options text when there are no options
    const displayNoOptionsText = safeOptions.length === 0 ? 'No results found' : noOptionsText;
    return (
        <FormControl fullWidth size="small" {...props}>
            <StyledAutocomplete
                onChange={(event, newValue) => {
                    if (onProductChange) {
                        onProductChange(newValue);
                    }
                }}
                inputValue={text}
                options={safeOptions}
                filterOptions={filterOptions}
                getOptionLabel={(option) => option?.label || ''}
                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                loading={loading}
                disabled={disabled}
                autoComplete={autoComplete}
                multiple={multiple}
                // freeSolo={freeSolo}
                disableClearable={true}
                noOptionsText={
                <NoOption>
                <ImgContainers src={HillSvg}/>
                <NoOptionsTypography>  {displayNoOptionsText}</NoOptionsTypography>
                </NoOption>
                }
                open={text.length > 0 && !loading}
                PaperComponent={({ children, ...other }) => (
                    <StyledPaper {...other}>
                        {children}
                    </StyledPaper>
                )}
                PopperComponent={StyledPopper}
                renderOption={(props, option) => (
                    <Box
                        component="li"
                        {...props}
                    >
                        <Box sx={{
                            display: 'flex',
                            gap: 1,
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            py: 0.5,
                            width: '100%'
                        }}>
                            <Box>
                                <OptionLabelTypography>
                                    {option.label}
                                </OptionLabelTypography>
                                {option.description && (
                                    <OptionDescriptionTypography>
                                        {option.description}
                                    </OptionDescriptionTypography>
                                )}
                            </Box>
                            {showCount && option.count !== undefined && (
                                <OptionCountTypography>
                                    {option.count > 0 ? `${option.count}` : ''}
                                </OptionCountTypography>
                            )}
                        </Box>
                    </Box>
                )}
                renderInput={(params) => (
                    <StyledTextField
                        size='small'
                        {...params}
                        placeholder={placeholder}
                        InputProps={{ ...params.InputProps, startAdornment: (<Search style={{ fontSize: '20px', color: "#b0afaf", padding: "0px 0px 4px 0px" }} />) }}
                        onChange={(e) => {
                            if (onSearchTextChange) {
                                onSearchTextChange(e.target.value)
                            }
                        }}
                    />
                )}
            />
        </FormControl>
    );
};

export default AutocompleteField;